export enum UploadStatus {
    InProgress = 0,
    Done = 1,
    Invalid = 2,
    Error = 3
}

export enum UploadErrorCode {
    FileToLarge = 1,
    FileTypeNotAllowed = 2,
    Exception = 3
}

export class UploadError {
    code: UploadErrorCode;
    message: string;
}

export enum FileType
{
    Unknown = 0,
    InternalImage = 2,
    PublicFile = 3,
    InternalFile = 4,
    InternalImagebank = 9,
    PublicImagebank = 10,
    PendingFile = 20,
    Temporary = 21,
    Destinero = 22
}

export class ImageInfo {
    width: number;
    height: number;
    latitude: number;
    longitude: number;
    artist: string;
    copyright: string;
    keywords: string;
    description: string;
    created: string;
}

export class UploadResponse {
    status: UploadStatus;
    information: ImageInfo;
    urlPath: string;
    filePath: string;
    error: UploadError;
    faceX: number;
    faceY: number;
    fileName: string;
    imageId: number;
}

export class UploadProgress {
    status: string;
    progress: number;
    fileName: string;
    body: UploadResponse;
}